import React from "react";
import { Link } from "react-router-dom";

import search from "../../public/search.svg";
import search_dark from "../../public/search_dark.svg";

import wheretogo_1 from "../../public/wheretogo-beskydy/wheretogo_1.png";
import wheretogo_2 from "../../public/wheretogo-beskydy/wheretogo_2.png";
import wheretogo_3 from "../../public/wheretogo-beskydy/wheretogo_3.png";
import wheretogo_4 from "../../public/wheretogo-beskydy/wheretogo_4.png";
import wheretogo_5 from "../../public/wheretogo-beskydy/wheretogo_5.png";

import { useUserContext } from "../../context/userContext";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const KamSeVydatVBeskydech = () => {
  
  const { user } = useUserContext();

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section
        className={darkMode ? "where__to--go dark" : "where__to--go light"}
      >
        <div className="container">
          <div className="where__to--go--heading">
            <img src={darkMode ? search_dark : search} alt="" />
            <h1 className={darkMode ? "dark-text" : "light-text"}>
              Kam se vydat v Beskydech
            </h1>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_1} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>
                Lysá Hora
              </h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Lysá hora je nejvyšší vrchol Moravskoslezských Beskyd. Tento
                vrch byl také v letech 1939 až 1945 nejvyšším bodem Protektorátu
                Čechy a Morava.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/beskydy/kamsevydat/lysahora"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_2} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>
                Pustevny
              </h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Pustevny jsou oblast, která je známá především svou tradiční
                lidovou architekturou a řadou kulturních památek. V celé oblasti
                je kromě řady možností ubytování i restaurací, kaváren a
                hospůdek.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/beskydy/kamsevydat/pustevny"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_3} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>
                Velký Javorník
              </h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Velký Javorník je vrchol v Beskydech. Leží na hranici mezi
                okresem Karviná a Frýdek-Místek. Dosahuje výšky 1 128 m nad
                mořem.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/beskydy/kamsevydat/velkyjavornik"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div className="container">
          {user ? (
            <div className="where__to--go--container">
              <div className="where__to--go--image">
                <img src={wheretogo_4} alt="" />
              </div>
              <div className="where__to--go--content">
                <h3 className={darkMode ? "dark-text" : "light-text"}>
                  V. n. Morávka
                </h3>
                <p
                  className={
                    darkMode ? "dark-second-text" : "light-second-text"
                  }
                >
                  Vodárenská údolní nádrž Morávka patří k soustavě nádrží v
                  povodí Odry, které zabezpečují systém Ostravského oblastního
                  vodovodu (OOV) a pomocí něj pak obyvatelstvo téměř celé
                  ostravské má pitnou vodou. Je situována v horské oblasti
                  Beskyd na horním toku řeky a ovládá povodí o velikosti 63,3
                  km2
                </p>
                <Link
                  className={
                    darkMode ? "dark-button-text" : "light-button-text"
                  }
                  to="/beskydy/kamsevydat/moravka"
                >
                  <span>Více</span>
                </Link>
              </div>
            </div>
          ) : (
            <div className="where__to--go--container ">
              <div className="where__to--go--image where__to--go--container--locked">
                <img src={wheretogo_4} alt="" />
              </div>
              <div className="where__to--go--content">
                <h3
                  className={
                    darkMode
                      ? "where__to--go--container--locked dark-text"
                      : "where__to--go--container--locked light-text"
                  }
                >
                  Pro registrované
                </h3>
                <p
                  className={
                    darkMode
                      ? "where__to--go--container--locked dark-second-text"
                      : "where__to--go--container--locked light-second-text"
                  }
                >
                  Zaregistrujte se už dnes a získejte přístup k prémiovým místům
                </p>
                <Link
                  to="/profile"
                  className={
                    darkMode
                      ? "where__to--go--container--locked dark-button-text"
                      : "where__to--go--container--locked light-button-text"
                  }
                >
                  <span>Více</span>
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div className="container">
          {user ? (
            <div className="where__to--go--container">
              <div className="where__to--go--image">
                <img src={wheretogo_5} alt="" />
              </div>
              <div className="where__to--go--content">
                <h3 className={darkMode ? "dark-text" : "light-text"}>
                  Javorový vrch
                </h3>
                <p
                  className={
                    darkMode ? "dark-second-text" : "light-second-text"
                  }
                >
                  Javorový vrch je hora v Beskydech v blízkosti města Třince.
                  Vrchol Dosahuje výšky 1032 m. Je zde turistická chata a
                  lyžařské sjezdovky. V okolí chaty jsou dostupné vynikající
                  běžecké trasy s celkovou délkou okolo 25 km.
                </p>
                <Link
                  className={
                    darkMode ? "dark-button-text" : "light-button-text"
                  }
                  to="/beskydy/kamsevydat/javorovy"
                >
                  <span>Více</span>
                </Link>
              </div>
            </div>
          ) : (
            <div className="where__to--go--container ">
              <div className="where__to--go--image where__to--go--container--locked">
                <img src={wheretogo_5} alt="" />
              </div>
              <div className="where__to--go--content">
                <h3
                  className={
                    darkMode
                      ? "where__to--go--container--locked dark-text"
                      : "where__to--go--container--locked light-text"
                  }
                >
                  Pro registrované
                </h3>
                <p
                  className={
                    darkMode
                      ? "where__to--go--container--locked dark-second-text"
                      : "where__to--go--container--locked light-second-text"
                  }
                >
                  Zaregistrujte se už dnes a získejte přístup k prémiovým místům
                </p>
                <Link
                  to="/profile"
                  className={
                    darkMode
                      ? "where__to--go--container--locked dark-button-text"
                      : "where__to--go--container--locked light-button-text"
                  }
                >
                  <span>Více</span>
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default KamSeVydatVBeskydech;
